import styled from "styled-components";

import { pxToRem } from "../../styles/utils";

const BrandTextLink = styled.a<{ $size?: "sm" | "md" | "lg" }>`
  color: ${({ theme }) => theme.colors.brand};
  font: inherit;
  font-size: ${({ $size, theme }) =>
    $size ? pxToRem(theme.fontSize[$size]) : "inherit"};
  line-height: 1.4;
  text-decoration: none;
  transition: color 0.15s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.brandDark};
    text-decoration: none;
  }

  &:focus-visible {
    border-radius: ${({ theme }) => pxToRem(theme.radii.sm)};
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
  }
`;

export default BrandTextLink;
